import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    resultado: [],
  },

  getters: {
    getResultado: (state) => state.resultado,
  },

  mutations: {
    SET_RESULTADO(state, resultado) {
      state.resultado = resultado;
    },
  },

  actions: {
    async fetchResultado({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catresultado')
        .then((response) => {
          commit('SET_RESULTADO', response.data.data);
        });
    },
  },
};
